import { cn } from '@/utils';

export interface FavouriteHeartIconProps {
  favouriteCount: number;
  className?: string;
}

export const FavouriteHeartIcon = ({ favouriteCount, className }: FavouriteHeartIconProps) => (
  <span
    className={cn(
      'relative flex h-[31px] w-[32px] items-center justify-center rounded-full transition duration-150 hover:bg-[#f7f7f7]',
      className,
    )}
  >
    <svg width="32" height="31" viewBox="0 0 32 31" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.28974 17.54L16.7997 30.05L29.2397 17.49C32.529 14.1662 32.529 8.81381 29.2397 5.49C27.6483 3.89834 25.4905 3.00287 23.2397 3C20.9881 2.99846 18.8287 3.89461 17.2397 5.49C17.0797 5.65 16.9297 5.82 16.7797 5.99L16.7797 5.98997C16.6297 5.81998 16.4797 5.64999 16.3197 5.49C14.7308 3.89461 12.5714 2.99846 10.3197 3C6.87472 2.99964 3.7685 5.07394 2.44878 8.25615C1.12906 11.4384 1.85558 15.1022 4.28974 17.54ZM4.29668 9.025C5.30573 6.58882 7.68285 5.00027 10.3197 5C12.0532 4.99308 13.7172 5.681 14.9397 6.91C15.3311 7.30283 15.6675 7.74686 15.9397 8.23L16.7997 9.7L17.6697 8.23C17.9419 7.74686 18.2783 7.30283 18.6697 6.91C21.2159 4.36423 25.3436 4.36423 27.8897 6.91C30.4355 9.45614 30.4355 13.5839 27.8897 16.13L16.7997 27.22L5.70974 16.13C3.84531 14.2653 3.28762 11.4612 4.29668 9.025Z"
      />
      <mask
        id="mask0_0_18342"
        className="mask-type-luminance"
        maskUnits="userSpaceOnUse"
        x="1"
        y="3"
        width="31"
        height="28"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.28974 17.54L16.7997 30.05L29.2397 17.49C32.529 14.1662 32.529 8.81381 29.2397 5.49C27.6483 3.89834 25.4905 3.00287 23.2397 3C20.9881 2.99846 18.8287 3.89461 17.2397 5.49C17.0797 5.65 16.9297 5.82 16.7797 5.99L16.7797 5.98997C16.6297 5.81998 16.4797 5.64999 16.3197 5.49C14.7308 3.89461 12.5714 2.99846 10.3197 3C6.87472 2.99964 3.7685 5.07394 2.44878 8.25615C1.12906 11.4384 1.85558 15.1022 4.28974 17.54ZM4.29668 9.025C5.30573 6.58882 7.68285 5.00027 10.3197 5C12.0532 4.99308 13.7172 5.681 14.9397 6.91C15.3311 7.30283 15.6675 7.74686 15.9397 8.23L16.7997 9.7L17.6697 8.23C17.9419 7.74686 18.2783 7.30283 18.6697 6.91C21.2159 4.36423 25.3436 4.36423 27.8897 6.91C30.4355 9.45614 30.4355 13.5839 27.8897 16.13L16.7997 27.22L5.70974 16.13C3.84531 14.2653 3.28762 11.4612 4.29668 9.025Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_0_18342)">
        <rect x="0.799805" width="32" height="32" fill="none" />
      </g>
    </svg>
    <span
      className="z-2 absolute right-0 top-0 h-5 w-5 -translate-y-[15%] translate-x-[30%] rounded-full border-2 border-gray-100
        bg-strawberry text-center text-xs leading-4 text-white"
    >
      {favouriteCount}
    </span>
  </span>
);
